var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7212 20.6443L16.6673 19.6L18.4923 17.75H13.9712V16.25H18.4923L16.6673 14.4L17.7212 13.3558L21.3652 17L17.7212 20.6443ZM13.3845 21.5C11.7192 21.5 10.3013 20.9163 9.13075 19.749C7.96025 18.5817 7.375 17.1653 7.375 15.5V14.9537C6.025 14.7782 4.89583 14.1763 3.9875 13.148C3.07917 12.1198 2.625 10.9038 2.625 9.5V3.75H5.625V2.75H7.125V6.25H5.625V5.25H4.125V9.5C4.125 10.6 4.51667 11.5417 5.3 12.325C6.08333 13.1083 7.025 13.5 8.125 13.5C9.225 13.5 10.1667 13.1083 10.95 12.325C11.7333 11.5417 12.125 10.6 12.125 9.5V5.25H10.625V6.25H9.125V2.75H10.625V3.75H13.625V9.5C13.625 10.9038 13.1708 12.1198 12.2625 13.148C11.3542 14.1763 10.225 14.7782 8.875 14.9537V15.5C8.875 16.75 9.31342 17.8125 10.1902 18.6875C11.0671 19.5625 12.1318 20 13.3845 20V21.5Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferal);
export default __webpack_public_path__ + "static/media/referal.eccc12934779314af4b067af11884f0e.svg";
export { ForwardRef as ReactComponent };